import { apiClient } from 'modules/apiClient';

type SubscribeProps = {
  plan: string;
  period: string;
  paymentMethodId: string;
};

type SubscribeResponse = {
  subscriptionId: string;
  clientSecret: string;
};

const subscribe = async ({
  plan,
  period,
  paymentMethodId,
}: SubscribeProps): Promise<SubscribeResponse> => {
  const response = await apiClient.post('/v1/subscriptions/subscribe', {
    plan,
    period,
    paymentMethodId,
  });
  return response.data;
};

type CheckoutProps = {
  plan: string;
  period: string;
};

type CheckoutResponse = {
  url: string;
};

const checkout = async ({
  plan,
  period,
}: CheckoutProps): Promise<CheckoutResponse> => {
  const response = await apiClient.post('/v1/subscriptions/checkout', {
    plan,
    period,
  });
  return response.data;
};

export const SubscriptionApi = { subscribe, checkout };
